import store from "../../../store";

export const getQuests = async (id) => {
    return await store.state.feedAPI.get('Quests/',{user_id :id});
  }